import React from 'react'
import { Dialog } from 'primereact/dialog'
import { Clock } from 'lucide-react'
import ActionButton from './ActionButton'
import '../Styles/SessionTimeoutDialog.scss'

const SessionTimeoutDialog = ({ visible, secondsLeft, onKeepAlive }) => {
    return (
        <Dialog
            className="session-timeout-dialog"
            header="Session expiring"
            visible={visible}
            closable={false}
            closeOnEscape={false}
            dismissableMask={false}
            draggable={false}
            resizable={false}
            modal
            position="center"
        >
            <div className="session-timeout-content">
                <Clock size={28} className="session-timeout-icon" aria-hidden="true" />
                <p>You've been inactive for a while. For your security, you'll be signed out in {secondsLeft}s.</p>
                <ActionButton className="session-timeout-btn" onClick={onKeepAlive}>
                    Keep me signed in
                </ActionButton>
            </div>
        </Dialog>
    )
}

export default SessionTimeoutDialog